import React from 'react';

const StrategyStatistics = (): React.ReactElement => {
  return <h2 className="default-title">No statistics yet...</h2>;
};

export default StrategyStatistics;
